import builder from '../builder';
import NotificationSettings from '../../streamline-icons/light/notification-settings.svg';

export default builder('IconNotificationSettingsLight', NotificationSettings);
